import axios from "axios";
import getServerURL from "utils/constants/api";

const baseURL = getServerURL();

const api = axios.create({
  baseURL,
  withCredentials: true,
});

export const GET_COURSES_FOR_ASSESSMENT = {
  method: "get",
  url: "/api/interlink/v1/course/self-assessment/all",
};

export const GET_COURSES_FOR_REGISTRATION = {
  method: "get",
  url: "/api/interlink/v1/course/registration/all",
};

export const CREATE_CANDIDATE_SUBMISSION = {
  method: "post",
  url: "/api/interlink/v1/assessment/candidate/create",
};

export const CALCULATE_RESULT_SUBMISSION = {
  method: "post",
  url: "/api/interlink/v1/assessment/calculate",
};

export const VALIDATE_CANDIDATE_ASSESSMENT = {
  method: "post",
  url: "/api/interlink/v1/assessment/candidate/approval/check",
};

export const CREATE_CANDIDATE_REGISTRATION = {
  method: "post",
  url: "/api/interlink/v1/registration/candidate/create",
};

export default api;
